import React from 'react'
import {FeatureAppDefinition, FeatureServices} from '@feature-hub/core'
import {ReactFeatureApp} from '@feature-hub/react'
import {FeatureServicesContext} from './use-feature-services'
import {ThemeProvider} from '@volkswagen-onehub/components-core'
import './i18n'
import {MyDealerService} from '@volkswagen-onehub/mydealer-service'
import {App} from './app/app'

export interface FeatureAppPosizioniAperteDependencies extends FeatureServices {
    readonly 'mydealer-service': MyDealerService
}

export interface FeatureAppPosizioniAperteConfig {
    backendUrl?: string
    layout?: 'standalone' | 'dealer'
    brandDesignVariant?: 'v19' | 'v26'
}

const getBrandDesignVariant = (
    variant: unknown
): FeatureAppPosizioniAperteConfig['brandDesignVariant'] =>
    variant === 'v19' || variant === 'v26' ? variant : undefined

export const featureAppDefinition: FeatureAppDefinition<
    ReactFeatureApp,
    FeatureAppPosizioniAperteDependencies,
    FeatureAppPosizioniAperteConfig
> = {
    dependencies: {
        featureServices: {
            'fa-content-service': '^1.0.0',
            'service-config-provider': '1.0.0',
            'tracking': '^1.0.0',
            'mydealer-service': '^2.0.0',
        },
    },
    create: ({featureAppId, featureServices, config}) => {
        const faContentService = featureServices['fa-content-service'] as any

        const backendUrl =
            (faContentService && faContentService.content?.backendUrl) ||
            config?.backendUrl

        const layout =
            (faContentService && faContentService.content?.layout) ||
            config?.layout
        const brandDesignVariant = getBrandDesignVariant(
            (faContentService &&
                faContentService.content?.brandDesignVariant) ||
                config?.brandDesignVariant
        )

        if (!backendUrl) {
            throw new Error('No backendUrl is configured!')
        }

        return {
            render() {
                return (
                    <FeatureServicesContext.Provider value={featureServices}>
                        <ThemeProvider
                            theme="main"
                            variant={brandDesignVariant}
                        >
                            <App
                                featureAppId={featureAppId}
                                backendUrl={backendUrl}
                                layout={layout}
                            />
                        </ThemeProvider>
                    </FeatureServicesContext.Provider>
                )
            },
        }
    },
}

export default featureAppDefinition
